/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HexVersionOAuthSettingsFragment = {
  readonly __typename: "HexVersionOAuthSettings";
  readonly id: c.HexVersionOAuthSettingsId;
  readonly logicViewTokenShared: boolean;
  readonly publishedAppTokenShared: boolean;
  readonly publishedAppTokenSharingAllowed: boolean;
  readonly canEdit: boolean;
};

export type UpdateCredentialsIncludedMutationVariables = Types.Exact<{
  hexVersionOAuthSettingsIds:
    | ReadonlyArray<Types.Scalars["HexVersionOAuthSettingsId"]["input"]>
    | Types.Scalars["HexVersionOAuthSettingsId"]["input"];
  credentialsIncluded: Types.Scalars["Boolean"]["input"];
}>;

export type UpdateCredentialsIncludedMutation = {
  readonly __typename: "Mutation";
  readonly bulkUpdateHexVersionOAuthSettings: ReadonlyArray<{
    readonly __typename: "HexVersionOAuthSettings";
    readonly id: c.HexVersionOAuthSettingsId;
    readonly logicViewTokenShared: boolean;
    readonly publishedAppTokenShared: boolean;
    readonly publishedAppTokenSharingAllowed: boolean;
    readonly canEdit: boolean;
  }>;
};

export type GetOAuthSettingsByHexVersionIdQueryVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
}>;

export type GetOAuthSettingsByHexVersionIdQuery = {
  readonly __typename: "Query";
  readonly hexVersionOAuthSettingsByHexVersionId: {
    readonly __typename: "HexVersionOAuthSettings";
    readonly id: c.HexVersionOAuthSettingsId;
  } | null;
};

export type GetHexShareSettingsByHexIdQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type GetHexShareSettingsByHexIdQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly publicRoleV2: Types.ProjectRole | null;
    readonly allowEmbedding: boolean;
  };
};

export const HexVersionOAuthSettingsFragmentDoc = /*#__PURE__*/ gql`
  fragment HexVersionOAuthSettingsFragment on HexVersionOAuthSettings {
    id
    logicViewTokenShared
    publishedAppTokenShared
    publishedAppTokenSharingAllowed
    canEdit
  }
`;
export const UpdateCredentialsIncludedDocument = /*#__PURE__*/ gql`
  mutation UpdateCredentialsIncluded(
    $hexVersionOAuthSettingsIds: [HexVersionOAuthSettingsId!]!
    $credentialsIncluded: Boolean!
  ) {
    bulkUpdateHexVersionOAuthSettings(
      hexVersionOAuthSettingsIds: $hexVersionOAuthSettingsIds
      publishedAppTokenShared: $credentialsIncluded
    ) {
      id
      ...HexVersionOAuthSettingsFragment
    }
  }
  ${HexVersionOAuthSettingsFragmentDoc}
`;
export type UpdateCredentialsIncludedMutationFn = Apollo.MutationFunction<
  UpdateCredentialsIncludedMutation,
  UpdateCredentialsIncludedMutationVariables
>;

/**
 * __useUpdateCredentialsIncludedMutation__
 *
 * To run a mutation, you first call `useUpdateCredentialsIncludedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCredentialsIncludedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCredentialsIncludedMutation, { data, loading, error }] = useUpdateCredentialsIncludedMutation({
 *   variables: {
 *      hexVersionOAuthSettingsIds: // value for 'hexVersionOAuthSettingsIds'
 *      credentialsIncluded: // value for 'credentialsIncluded'
 *   },
 * });
 */
export function useUpdateCredentialsIncludedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCredentialsIncludedMutation,
    UpdateCredentialsIncludedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCredentialsIncludedMutation,
    UpdateCredentialsIncludedMutationVariables
  >(UpdateCredentialsIncludedDocument, options);
}
export type UpdateCredentialsIncludedMutationHookResult = ReturnType<
  typeof useUpdateCredentialsIncludedMutation
>;
export type UpdateCredentialsIncludedMutationResult =
  Apollo.MutationResult<UpdateCredentialsIncludedMutation>;
export type UpdateCredentialsIncludedMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCredentialsIncludedMutation,
    UpdateCredentialsIncludedMutationVariables
  >;
export const GetOAuthSettingsByHexVersionIdDocument = /*#__PURE__*/ gql`
  query GetOAuthSettingsByHexVersionId($hexVersionId: HexVersionId!) {
    hexVersionOAuthSettingsByHexVersionId(hexVersionId: $hexVersionId) {
      id
    }
  }
`;

/**
 * __useGetOAuthSettingsByHexVersionIdQuery__
 *
 * To run a query within a React component, call `useGetOAuthSettingsByHexVersionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthSettingsByHexVersionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthSettingsByHexVersionIdQuery({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *   },
 * });
 */
export function useGetOAuthSettingsByHexVersionIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOAuthSettingsByHexVersionIdQuery,
    GetOAuthSettingsByHexVersionIdQueryVariables
  > &
    (
      | {
          variables: GetOAuthSettingsByHexVersionIdQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOAuthSettingsByHexVersionIdQuery,
    GetOAuthSettingsByHexVersionIdQueryVariables
  >(GetOAuthSettingsByHexVersionIdDocument, options);
}
export function useGetOAuthSettingsByHexVersionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOAuthSettingsByHexVersionIdQuery,
    GetOAuthSettingsByHexVersionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOAuthSettingsByHexVersionIdQuery,
    GetOAuthSettingsByHexVersionIdQueryVariables
  >(GetOAuthSettingsByHexVersionIdDocument, options);
}
export function useGetOAuthSettingsByHexVersionIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOAuthSettingsByHexVersionIdQuery,
    GetOAuthSettingsByHexVersionIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOAuthSettingsByHexVersionIdQuery,
    GetOAuthSettingsByHexVersionIdQueryVariables
  >(GetOAuthSettingsByHexVersionIdDocument, options);
}
export type GetOAuthSettingsByHexVersionIdQueryHookResult = ReturnType<
  typeof useGetOAuthSettingsByHexVersionIdQuery
>;
export type GetOAuthSettingsByHexVersionIdLazyQueryHookResult = ReturnType<
  typeof useGetOAuthSettingsByHexVersionIdLazyQuery
>;
export type GetOAuthSettingsByHexVersionIdSuspenseQueryHookResult = ReturnType<
  typeof useGetOAuthSettingsByHexVersionIdSuspenseQuery
>;
export type GetOAuthSettingsByHexVersionIdQueryResult = Apollo.QueryResult<
  GetOAuthSettingsByHexVersionIdQuery,
  GetOAuthSettingsByHexVersionIdQueryVariables
>;
export const GetHexShareSettingsByHexIdDocument = /*#__PURE__*/ gql`
  query GetHexShareSettingsByHexId($hexId: HexId!) {
    hexById(hexId: $hexId) {
      id
      publicRoleV2
      allowEmbedding
    }
  }
`;

/**
 * __useGetHexShareSettingsByHexIdQuery__
 *
 * To run a query within a React component, call `useGetHexShareSettingsByHexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexShareSettingsByHexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexShareSettingsByHexIdQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useGetHexShareSettingsByHexIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHexShareSettingsByHexIdQuery,
    GetHexShareSettingsByHexIdQueryVariables
  > &
    (
      | { variables: GetHexShareSettingsByHexIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHexShareSettingsByHexIdQuery,
    GetHexShareSettingsByHexIdQueryVariables
  >(GetHexShareSettingsByHexIdDocument, options);
}
export function useGetHexShareSettingsByHexIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexShareSettingsByHexIdQuery,
    GetHexShareSettingsByHexIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHexShareSettingsByHexIdQuery,
    GetHexShareSettingsByHexIdQueryVariables
  >(GetHexShareSettingsByHexIdDocument, options);
}
export function useGetHexShareSettingsByHexIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexShareSettingsByHexIdQuery,
    GetHexShareSettingsByHexIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexShareSettingsByHexIdQuery,
    GetHexShareSettingsByHexIdQueryVariables
  >(GetHexShareSettingsByHexIdDocument, options);
}
export type GetHexShareSettingsByHexIdQueryHookResult = ReturnType<
  typeof useGetHexShareSettingsByHexIdQuery
>;
export type GetHexShareSettingsByHexIdLazyQueryHookResult = ReturnType<
  typeof useGetHexShareSettingsByHexIdLazyQuery
>;
export type GetHexShareSettingsByHexIdSuspenseQueryHookResult = ReturnType<
  typeof useGetHexShareSettingsByHexIdSuspenseQuery
>;
export type GetHexShareSettingsByHexIdQueryResult = Apollo.QueryResult<
  GetHexShareSettingsByHexIdQuery,
  GetHexShareSettingsByHexIdQueryVariables
>;
